import { defineMessages } from 'react-intl';

export default defineMessages({
  paymentMethodsTitle: {
    id:
      'app.conversion.pages.shopInfo.components.PaymentMethods.paymentMethodsTitle',
    defaultMessage: 'Formas de pago',
  },
  onlinePayment: {
    id: 'app.conversion.pages.shopInfo.components.PaymentMethods.online',
    defaultMessage: 'Online',
  },
  cashPayment: {
    id: 'app.conversion.pages.shopInfo.components.PaymentMethods.cash',
    defaultMessage: 'En la entrega',
  },
  cashPaymentName: {
    id:
      'app.conversion.pages.shopInfo.components.PaymentMethods.cashPaymentName',
    defaultMessage: 'Efectivo',
  },
});
